<!-- Main Alert. The root carries the `gs` query container: it spans the viewport, so projected
     content resolves against the same width as the page, even once the alert is moved to the body. -->
@let hasHeader = showHeader();
@let blockDismiss = forceInput();
@let textClass = textStyle();
<div
  #alertRef
  tabindex="-1"
  role="dialog"
  aria-modal="true"
  [attr.aria-labelledby]="hasHeader ? titleId : ariaLabel() ? null : messageId"
  [attr.aria-label]="!hasHeader ? ariaLabel() : null"
  [attr.aria-describedby]="messageId"
  [gsFocusTrap]="opened()"
  (keydown.escape)="dismiss()"
  class="gs-responsive-container fixed left-0 top-0 z-50 hidden h-full max-h-full w-full items-center justify-center md:inset-0"
>
  <button
    type="button"
    tabindex="-1"
    aria-hidden="true"
    class="absolute h-full w-full cursor-default bg-black/40"
    (click)="enableBackdrop() && !blockDismiss ? dismiss() : null"
  ></button>

  <div [class]="'relative max-h-full w-full max-w-3xl overflow-y-auto overflow-x-hidden p-4 ' + (alertStyle() ?? '')">
    <!-- Alert content -->
    <div class="relative overflow-hidden bg-white shadow" [ngClass]="{ 'rounded-lg': roundedCorners() }">
      <!-- Alert header -->
      @if (hasHeader) {
        <div
          [class]="
            'border-primary-shade text-primary-contrast sticky top-0 flex items-center justify-between border-b p-2 md:p-5 ' +
            (headerStyle() ?? '')
          "
        >
          <span [id]="titleId" class="text-xl font-semibold">
            {{ title() }}
          </span>
          @if (!blockDismiss) {
            <button
              type="button"
              class="ms-auto inline-flex h-8 w-8 items-center justify-center rounded-md bg-transparent text-sm text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-700"
              (click)="dismiss()"
            >
              <svg class="h-3 w-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14">
                <path
                  stroke="currentColor"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
                />
              </svg>
              <span class="sr-only">Fenster schließen</span>
            </button>
          }
        </div>
      }

      <!-- Alert body -->
      <div [class]="'sticky top-0 flex items-center justify-between p-4 md:p-5 ' + bodyStyle()">
        <p [id]="messageId" [class]="textClass != null ? textClass : 'text-inherit'">{{ message() }}</p>
      </div>

      <!-- Alert footer -->
      <div [class]="'sticky bottom-0 block bg-white dark:bg-gray-800 ' + (footerStyle() ?? '')">
        <ng-content select="[footer]"></ng-content>
      </div>
    </div>
  </div>
</div>
